import { render, staticRenderFns } from "./CreateContactView.vue?vue&type=template&id=2e686132&scoped=true&"
import script from "./CreateContactView.vue?vue&type=script&lang=ts&"
export * from "./CreateContactView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e686132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e686132')) {
      api.createRecord('2e686132', component.options)
    } else {
      api.reload('2e686132', component.options)
    }
    module.hot.accept("./CreateContactView.vue?vue&type=template&id=2e686132&scoped=true&", function () {
      api.rerender('2e686132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/management/views/CreateContactView.vue"
export default component.exports